var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StaticLoader"},[_c('div',{staticClass:"StaticLoader-border"}),_c('icon',{attrs:{"name":"icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }